import { computed, inject, Injectable } from '@angular/core';
import { CompanyRole } from '../../api/models/fraud.models';
import {
  hasExchangeRole,
  hasFreezeAccess,
  isCompanyOwner,
} from '../utils/account-access.utils';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class AccountAccessService {
  private readonly _authService = inject(AuthService);

  readonly account = computed(() => this._authService.accountDto());
  readonly isExchangeRole = computed(() => hasExchangeRole(this.account()));
  // readonly isRecoveryPartner = computed(() => isRecoveryPartner(this.account()));
  readonly isAccessToFreeze = computed(() => hasFreezeAccess(this.account()));
  readonly isCompanyOwner = computed(() => isCompanyOwner(this.account()));

  hasFreezeAccess(allowedCorporateRoles: readonly CompanyRole[]): boolean {
    return hasFreezeAccess(this.account(), allowedCorporateRoles);
  }
}
